module.exports = __webpack_public_path__ + "static/media/builder.a5dbaf75.jpg";